export default __webpack_public_path__ + "static/media/67t.6546b97c.jpg";